import { useMemo } from 'react'
import { useProductOffersContext } from '@/contexts/productOffers'
import { useFetch } from '@/hooks/useFetch'
import { type SKUListing } from '@/types/product'

export function useSKUs(productId: number, isActive = true) {
  const { productOffers } = useProductOffersContext()

  const { data: skus = [], ...result } = useFetch<SKUListing[]>(
    ({ account }) =>
      `/api/proxy/catalog/pvt/admin/product/${String(
        productId
      )}/skus?an=${account}`,
    { isActive, revalidateIfStale: true }
  )

  const skusWithOffers = useMemo<SKUListing[]>(() => {
    const product = productOffers?.find(
      (productOffer) => productOffer.ProductId === String(productId)
    )

    return skus.map((sku) => {
      const offer = product?.Skus?.find(
        (offerSku) => String(offerSku.id) === String(sku.id)
      )

      return {
        ...sku,
        isVisibleInPortal: !!offer,
        sellers: offer?.sellers ?? [],
      }
    })
  }, [productId, productOffers, skus])

  return { ...result, data: skusWithOffers }
}
